import { Card, Flex, Spin, theme, Typography } from 'antd';
import { DotLottieReact } from '@lottiefiles/dotlottie-react';
import roadCarBlue from 'Static/animations/roadCarBlue.lottie';
import loadingDotsBlue from 'Static/animations/loadingDotsBlue.lottie';

const { Text, Title } = Typography;

export const QuotationLoadingScreen = ({ loading, isExternal }) => {
  const { token: themeToken } = theme.useToken();

  const title = isExternal
    ? '¡Tu cotización se está creando!'
    : '¡Tus cotizaciones vienen en camino!';

  const description = isExternal
    ? 'Estamos analizando los datos de la cotización para asegurarnos de que se guarden correctamente.'
    : 'Analizamos los datos del vehículo y generamos las mejores opciones para tu cliente.';

  return (
    <Spin
      fullscreen
      spinning={loading}
      indicator={
        <Card
          style={{
            width: 'auto',
            height: 'auto',
            maxWidth: '25em',
            margin: '4vw',
          }}
        >
          <Flex vertical gap={8} align='center'>
            <Title level={3} style={{ color: themeToken.colorPrimary, margin: 0 }}>{title}</Title>
            <DotLottieReact
              src={roadCarBlue}
              loop
              autoplay
              style={{ height: 200 }}
              renderConfig={{ autoResize: true }}
            />
            <Text style={{ color: themeToken.colorPrimary }}>{description}</Text>
            <DotLottieReact
              src={loadingDotsBlue}
              loop
              autoplay
              style={{ height: '1em' }}
              renderConfig={{ autoResize: true }}
            />
          </Flex>
        </Card>
      }
    >
    </Spin>
  );
};